export default __webpack_public_path__ + "static/media/Capture.316b5d2a.PNG";